import { Checkbox, Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { hasValueInList } from '../../../helpers/array';
import PermissoesHelper from '../../../helpers/PermissoesHelper';
import { Card, LabelCheckbox, SubTitleCard } from './styles';

export default function Permissoes({
  selectedPermissions,
  onSelectPermission,
}) {
  const [permissoesExistentes, setPermissoesExistentes] = useState({});

  useEffect(() => {
    async function getPermissoes() {
      const permissoes = await PermissoesHelper.getPermissoesAgrupadas(false);
      setPermissoesExistentes(permissoes);
    }

    getPermissoes();
  }, []);

  return (
    <Col xs={24} lg={24} xl={24} className="mt-20">
      {Object.keys(permissoesExistentes).map(grupo => (
        <Col className="padding" span={24} key={grupo}>
          <SubTitleCard>{grupo}</SubTitleCard>
          <Card>
            <Row>
              {permissoesExistentes[grupo].map(({ id, name }) => (
                <Col xs={24} sm={9} md={9} lg={8} xl={6} key={id}>
                  <Checkbox
                    value={id}
                    checked={hasValueInList(selectedPermissions, 'id', id)}
                    onChange={() => onSelectPermission(id)}
                  >
                    <LabelCheckbox>{name}</LabelCheckbox>
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </Card>
        </Col>
      ))}
    </Col>
  );
}

Permissoes.propTypes = {
  selectedPermissions: PropTypes.instanceOf(Array),
  onSelectPermission: PropTypes.func.isRequired,
};

Permissoes.defaultProps = {
  selectedPermissions: [],
};
